var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.appComponent,{tag:"component"},[_c('v-global-error')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }